import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';
import { home } from '../config';
import Route from './routes';
import SignIn from '../pages/SignIn';
import Sobre from '../pages/Sobre';
import SignInAdmin from '../pages/SignInAdmin';
import SignUp from '../pages/SignUp';
import RecoverPassword from '../pages/RecoverPassword';
import ResetPassword from '../pages/ResetPassword';
import Products from '../pages/Products';

import VideosDashboard from '../pages/VideosDashboard';
import Dashboard from '../pages/DashboardPages';

import Home from '../pages/Home';
import AreaExposicao from '../pages/AreaExposicao';
import Expositor from '../pages/Expositor';
import Galeria from '../pages/Galeria';
import ExpositorChat from '../pages/ExpositorChat';
import SigninExpositor from '../pages/SigninExpositor';
import Program from '../pages/Program';
import Poster from '../pages/Poster';

import Speakers from '../pages/Speakers';
import Zoom from '../components/ZoomStarter';
import SpeakerLink from '../pages/SpeakerLink';
import ModeratorLink from '../pages/ModeratorLink';
import Validate from '../pages/DashboardPages/features/AuthIntegration';
import HomeApplication from '../PagesApplication/HomeApplication';
import GreenRoom from '../pages/GreenRoom';
import UserHome from '../pages/DashboardUserPages/Pages/Home';
import FileGallerys from '../pages/FileGallery';
import Sponsors from '../pages/SponsorsPage';
import ProgramTheme from '../PagesApplication/HomeApplication/modules/Program';
import Certificados from '../pages/Certificados';
import SurveyView from '../pages/DashboardPages/features/SurveyByURL';
import CientificLibraryAuthor from '../pages/CientificLibraryAuthor';
import CientificLibrary from '../pages/CientificLibrary';

import SelecionarData from '../pages/SelecionarDatas';
import UserDashboard from '../pages/DashboardUserPages/Pages/Home';
import ListarEventos from '../pages/ListarEventos';
import Termos from '../pages/Termos';
import SignInUpdate from '../pages/SignInUpdate';
import Subscription from '../pages/Subscription';

import LoginProduct from '../pages/Products/modules/Login'
import PaymentMethod from '../pages/Products/modules/PaymentMethod';
import PaymentConfirmation from '../pages/Products/modules/PaymentConfirmation';
import SignInLeitorConfirmacao from '../pages/SignInLeitorConfirmacao';
import AreaConfirmacao from '../pages/AreaConfirmacao';
import AreaConfirmacaoCurso from '../pages/AreaConfirmacaoCurso';


import AreaAtendimento from '../pages/AreaAtendimento';
import Autoatendimento from '../pages/AutoAtendimento';
import SignInAutoatendimento from '../pages/SignInAutoatendimento';
import AreaExpositor from '../pages/AreaExpositor';
import SignInExpositor from '../pages/SigninExpositor';
import CheckinQR from '../pages/DashboardPages/features/CheckinQR';
import SignInEquipe from '../pages/SignInEquipe';
import CortesyForm from '../pages/CortesyForm';
import TransferProductForm from '../pages/TransferProductForm';
import Politica from '../pages/Politica';

import ProductsSimplified from '../pages/ProductsSimplified';
import PaymentConfirmationV4 from '../pages/ProductsSimplified/modules/PaymentConfirmation';

import CertificadosValidar from '../pages/CertificadosValidar';
import EventsPages from '../PagesApplication/HomeApplication/modules/Paginas';
import ProductsWithTicket from '../pages/ProductsSimplifiedWithTicket';
import CourseClassroom from 'src/components/CourseClassroom';


import ProductsWithTicketEvent from '../pages/ProductsSimplifiedWithTicketEvent';
import ProgramClean from 'src/pages/ProgramClean';
import SpeakerConfirmationComponent from 'src/pages/DashboardPages/features/SpeakerConfirmationPage';
import SignInIngressos from 'src/pages/SignInIngressos';

const ValidPaths = {
  SignIn,
  SignInAdmin,
  SignUp,
  RecoverPassword,
  ResetPassword,
  Products,
  VideosDashboard,

  Home,
  Sobre,
};

const Routes: React.FC = () => {
  return (<Suspense fallback={<></>}>
    <Switch>
      <Route

        path="/"
        exact
        component={ValidPaths[home] ? ValidPaths[home] : Home}
      />
      <Route path="/validar-certificado/:hash" component={CertificadosValidar} />
      <Route

        path="/app/:projectHash/validar-cortesia/:hashcode"
        component={CortesyForm}
      />
      <Route

        path="/app/:projectHash/validar-ingresso/:hashcode"
        component={TransferProductForm}
      />

      <Route

        path="/app/:projectHash/login-autoatendimento"
        component={SignInAutoatendimento}
      />

      <Route
        template={'page'}
        isPrivate
        path="/app/:projectHash/autoatendimento"
        component={Autoatendimento}
      />

      <Route

        path="/app/:projectHash/area-de-atendimento"
        component={AreaAtendimento}
      />

      <Route path="/app/:projectHash/login-atendimento" component={SignInEquipe} />
      <Route path="/app/:projectHash/login-expositor" component={SignInExpositor} />
      <Route
        path="/app/:projectHash/area-expositor"



        component={AreaExpositor}
      />
      <Route
        path="/app/:projectHash/checkin"



        component={CheckinQR}
      />

      <Route template={'page'} isPrivate isSecret path="/app/:projectHash/dashboard/green-room/:id" component={GreenRoom} />

      <Route

        path="/acessar-leitor"
        component={SignInLeitorConfirmacao}
      />

      <Route

        path="/area-de-confirmacao"
        component={AreaConfirmacao}
      />
      <Route

        path="/app/:projectHash/login-ingressos"
        component={SignInIngressos}
      />


      <Route
        isPrivate
        path="/app/:projectHash/event/:eventHash/tickets-dashboard/"
        component={UserDashboard}
      />

      <Route
        isPrivate
        path="/app/:projectHash/tickets-dashboard/"
        component={UserDashboard}
      />


      <Route
        isPrivate
        path="/user-dashboard"
        component={UserDashboard}
      />
      <Route

        path="/app/:projectHash/credenciar-curso/:course"
        component={AreaConfirmacaoCurso}
      />
      <Route path="/app/:projectHash/event/:eventHash/recuperar_senha" component={RecoverPassword} />
      <Route path="/app/:projectHash/recuperar_senha" component={RecoverPassword} />

      <Route path="/recuperar_senha" component={RecoverPassword} />

      <Route path="/app/:projectHash/event/:eventHash/reset_password/:key" component={ResetPassword} />
      <Route path="/app/:projectHash/reset_password/:key" component={ResetPassword} />
      <Route path="/reset_password/:key" component={ResetPassword} />

      <Route path="/app/:projectHash/speaker-invitation/:hash" component={SpeakerConfirmationComponent} />



      <Route path="/app/:projectHash/checkout/event/:eventHash/:product_hash" component={PaymentMethod} />
      <Route path="/app/:projectHash/checkout/:product_hash" component={PaymentMethod} />
      <Route path="/app/:projectHash/event/:eventHash/payment/success/:payment_hash" component={PaymentConfirmation} />
      <Route path="/app/:projectHash/payment/success/:payment_hash" component={PaymentConfirmation} />

      <Route path="/atualizar-cadastro" component={SignInUpdate} />
      <Route path="/biblioteca-cientifica/autores" component={CientificLibraryAuthor} />
      <Route path="/biblioteca-cientifica/artigos/:posterid" component={CientificLibrary} />
      <Route path="/biblioteca-cientifica/categoria/:eixo" component={CientificLibrary} />
      <Route path="/biblioteca-cientifica" component={CientificLibrary} />

      <Route path="/eventos/:categoryName" component={ListarEventos} />
      <Route path="/eventos" component={ListarEventos} />


      <Route path="/app/:projectHash/arquivos-de-apoio" component={FileGallerys} />
      <Route path="/app/:projectHash/event/:eventHash/programacao" component={Program} />
      <Route path="/app/:projectHash/programacao" component={ProgramTheme} />
      <Route path="/app/:projectHash/paginas/:url" component={EventsPages} />
      <Route path="/app/:projectHash/login/" component={SignIn} />
      <Route path="/app/:projectHash/login-ingressos/" component={SignInIngressos} />
      {/*  <Route path="/app/:projectHash/inscricao/" component={SignUp} />
      <Route path="/inscricao/" component={SignUp} /> */}
      <Route path="/app/:projectHash/event/:eventHash/survey/:survey_id" component={SurveyView} />
      <Route path="/app/:projectHash/survey/:survey_id" component={SurveyView} />

      <Route path="/app/:projectHash/event/:eventHash/login/" component={SignIn} />

      <Route path="/app/:projectHash/cursos/" component={CourseClassroom} />


      <Route path="/app/:projectHash/event/:eventHash/arquivos-de-apoio" component={FileGallerys} />
      <Route path="/app/:projectHash/event/:eventHash/certificados" component={Certificados} />

      {/* <Route path="/app/:projectHash/registro/:product_hash" component={LoginProduct} /> */}
      <Route path="/app/:projectHash/event/:eventHash/palestrantes" component={Speakers} />
      <Route path="/app/:projectHash/event/:eventHash/patrocinadores" component={Sponsors} />
      <Route path="/app/:projectHash/event/:eventHash/inscricao" component={ProductsWithTicket} />
      <Route path="/app/:projectHash/selecionar-data" component={SelecionarData} />
      <Route path="/app/:projectHash/inscricao/:productId" component={ProductsWithTicket} />
      <Route path="/app/:projectHash/certificados" component={Certificados} />
      <Route path="/certificados" component={Certificados} />

      <Route path="/app/:projectHash/patrocinadores" component={Sponsors} />
      <Route path="/app/:projectHash/inscricao" component={ProductsWithTicket} />
      <Route path="/app/:projectHash/seja-premium" component={ProductsSimplified} />




      <Route path="/app/:projectHash/inscricao-b" component={ProductsWithTicket} />
      <Route path="/app/:projectHash/event/:eventHash/payment/v4/success/:payment_hash" component={PaymentConfirmationV4} />
      <Route path="/app/:projectHash/payment/v4/success/:payment_hash" component={PaymentConfirmationV4} />

      <Route

        path="/app/:projectHash/event/:eventHash/dashboard/:videoIdItem"
        component={CourseClassroom}
      />

      <Route

        path="/app/:projectHash/event/:eventHash/dashboard/"
        component={CourseClassroom}
      />
      <Route

        path="/app/:projectHash/dashboard/:videoIdItem"
        component={CourseClassroom}
      />
      <Route

        path="/app/:projectHash/dashboard/"
        component={CourseClassroom}
      />


      <Route isPrivate path="/app/:projectHash/poster" component={Poster} />

      <Route path="/app/:projectHash/event/:eventHash" component={HomeApplication} />
      <Route path="/app/:projectHash" component={HomeApplication} />

      <Route template="client" path="/validate/:hash" component={Validate} />
      <Route template="client" path="/events/access/:hash" component={SpeakerLink} />
      <Route path="/zoom" component={Zoom} />

      <Route path="/moderator/access/:projectHash/:hash" component={ModeratorLink} />

      <Route path="/exposicao" component={AreaExposicao} />
      <Route path="/termos" component={Termos} />
      <Route path="/politica" component={Politica} />
      <Route template="client" path="/admin" component={SignInAdmin} />
      <Route isPrivate path="/login_expositor" component={SigninExpositor} />

      <Route

        path="/expositores/:link_name"
        template="page"
        component={ExpositorChat}
      />
      <Route
        isPrivate
        path="/galeria/:link_name"
        template="page"
        component={Galeria}
      />
      <Route
        isPrivate
        path="/expositores_chat/:link_name"
        template="page"
        component={ExpositorChat}
      />


      <Route
        path="/manager/:tab/:projectHash/:eventHash"
        template="dashboard"
        isPrivate
        isSecret
        component={Dashboard}
      />


      <Route
        path="/manager/:tab/:projectHash"
        template="dashboard"
        isPrivate
        isSecret
        component={Dashboard}
      />

      <Route
        path="/manager/:tab"
        template="dashboard"
        isPrivate
        isSecret
        component={Dashboard}
      />
      <Route
        path="/manager"
        template="dashboard"
        isPrivate
        exact
        isSecret
        component={Dashboard}
      />


    </Switch>
  </Suspense>
  );
};

export default Routes;
